/* eslint-disable no-console */
import * as ngCommon from '@angular/common';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule, SwUpdate } from '@angular/service-worker';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TextMaskModule } from 'angular2-text-mask-ivy';
import { FileUploadModule } from 'ng2-file-upload';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxCaptchaModule } from 'ngx-captcha';
import { CookieService } from 'ngx-cookie-service';
import { ImageCropperModule } from 'ngx-image-cropper';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar-portable';
import { FileUploadModule as PrimeNgFileUploadModule } from 'primeng/fileupload';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { filter } from 'rxjs';
import { EafModule } from 'src/assets/lib/eaf-ng2-module';
import { CoreModule } from 'src/assets/lib/metronic/app/core/core.module';
import { LayoutConfigService } from 'src/assets/lib/metronic/app/core/services/layout-config.service';
import { LayoutRefService } from 'src/assets/lib/metronic/app/core/services/layout-ref.service';
import { UtilsService } from 'src/assets/lib/metronic/app/core/services/utils.service';
import { AppConsts } from 'src/shared/AppConsts';
import { ServiceProxyModule } from 'src/shared/service-proxies/service-proxy.module';
import { UtilsModule } from 'src/shared/utils/utils.module';

import { environment } from '../environments/environment';
import { ImpersonationService } from './admin/users/impersonation.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppCommonModule } from './shared/common/app-common.module';
import { LoginAttemptsModalComponent } from './shared/layout/login-attempts-modal.component';
import { AdmBarComponent } from './shared/layout/nav/adm-bar.component';
import { SideBarMenuComponent } from './shared/layout/nav/side-bar-menu.component';
import { TopBarMenuComponent } from './shared/layout/nav/top-bar-menu.component';
import { HeaderNotificationsComponent } from './shared/layout/notifications/header-notifications.component';
import { NotificationSettingsModalComponent } from './shared/layout/notifications/notification-settings-modal.component';
import { NotificationsComponent } from './shared/layout/notifications/notifications.component';
import { UserNotificationHelper } from './shared/layout/notifications/UserNotificationHelper';
import { ChangePasswordModalComponent } from './shared/layout/profile/change-password-modal.component';
import { ChangeProfilePictureModalComponent } from './shared/layout/profile/change-profile-picture-modal.component';
import { MySettingsModalComponent } from './shared/layout/profile/my-settings-modal.component';
import { DefaultBrandComponent } from './shared/layout/themes/default/default-brand.component';
import { DefaultLayoutComponent } from './shared/layout/themes/default/default-layout.component';
import { Theme2BrandComponent } from './shared/layout/themes/theme2/theme2-brand.component';
import { Theme2LayoutComponent } from './shared/layout/themes/theme2/theme2-layout.component';
import { Theme3BrandComponent } from './shared/layout/themes/theme3/theme3-brand.component';
import { Theme3LayoutComponent } from './shared/layout/themes/theme3/theme3-layout.component';
import { Theme4BrandComponent } from './shared/layout/themes/theme4/theme4-brand.component';
import { Theme4LayoutComponent } from './shared/layout/themes/theme4/theme4-layout.component';
import { TitleBarComponent } from './shared/layout/titlebar.component';
import { TopBarComponent } from './shared/layout/topbar.component';

// Metronic
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  // suppressScrollX: true
};

export const googleTagManager = () => AppConsts.googleTagManager;

@NgModule({
  declarations: [
    AppComponent,
    DefaultLayoutComponent,
    Theme4LayoutComponent,
    Theme2LayoutComponent,
    Theme3LayoutComponent,
    HeaderNotificationsComponent,
    SideBarMenuComponent,
    AdmBarComponent,
    TopBarMenuComponent,
    LoginAttemptsModalComponent,
    ChangePasswordModalComponent,
    ChangeProfilePictureModalComponent,
    MySettingsModalComponent,
    NotificationsComponent,
    NotificationSettingsModalComponent,
    TopBarComponent,
    TitleBarComponent,
    DefaultBrandComponent,
    Theme4BrandComponent,
    Theme2BrandComponent,
    Theme3BrandComponent,
  ],
  imports: [
    ngCommon.CommonModule,
    FormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    TabsModule.forRoot(),
    BsDropdownModule.forRoot(),
    PopoverModule.forRoot(),
    FileUploadModule,
    EafModule,
    AppRoutingModule,
    UtilsModule,
    ServiceProxyModule,
    TableModule,
    PaginatorModule,
    PrimeNgFileUploadModule,
    ProgressBarModule,
    PerfectScrollbarModule,
    CoreModule,
    NgxChartsModule,
    TextMaskModule,
    ImageCropperModule,
    NgxCaptchaModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    BrowserAnimationsModule,
    AppCommonModule,
  ],
  providers: [
    ImpersonationService,
    UserNotificationHelper,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    LayoutConfigService,
    UtilsService,
    LayoutRefService,
    CookieService,
    { provide: 'googleTagManagerId', useValue: googleTagManager() },
  ],
})
export class AppModule {
  constructor(public updates: SwUpdate) {
    if (updates.isEnabled) {
      // Substitui updates.activated.subscribe
      updates.versionUpdates.pipe(filter(event => event.type === 'VERSION_READY')).subscribe(event => {
        if (event.type === 'VERSION_READY') {
          console.log('Versão atual:', event.currentVersion);
          console.log('Nova versão disponível:', event.latestVersion);

          // Ativar a atualização
          updates.activateUpdate().then(() => this.updateApp());
        }
      });
    }
  }

  // Método para atualizar o aplicativo
  private updateApp(): void {
    console.log('A aplicação foi atualizada. Recarregando...');
    document.location.reload();
  }
}
